/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prompt: NonNullable<unknown> }} Assistant_Restore_EventInputs */



/**
* | output |
* | --- |
* | "Restored to the checkpoint before “{prompt}”" |
*
* @param {Assistant_Restore_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_event = /** @type {((inputs: Assistant_Restore_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Restauration au point de contrôle précédent « ${i?.prompt} »`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Wiederherstellung auf den Prüfpunkt vor „${i?.prompt}“`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ripristino al checkpoint precedente a “${i?.prompt}”`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Восстановлено до контрольной точки перед «${i?.prompt}»`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Restaurado al punto de control anterior a “${i?.prompt}”`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已恢复到“${i?.prompt}”之前的检查点`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.prompt}」より前のチェックポイントに復元されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`“${i?.prompt}” से पहले वाले चेकपॉइंट पर पुनर्स्थापित किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Retornou ao ponto de verificação anterior a “${i?.prompt}”`)
	return /** @type {LocalizedString} */ (`Restored to the checkpoint before “${i?.prompt}”`)
});